/**
 * The front door.
 *
 * One field. Everything else on this page exists to answer the two questions
 * a mother has before typing her address: what is this, and what happens to
 * my class's data.
 */

import { useState } from 'react';
import { api, ApiError } from '../api.js';

export function Landing() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      await api.post('/api/auth/magic-link', { email });
      setSent(true);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'Não conseguimos enviar agora.',
      );
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="page landing">
        <div className="banner ok">Link enviado.</div>
        <h1>Confira seu e-mail</h1>
        <p>
          Mandamos um link para <strong>{email}</strong>. Ele vale por 15
          minutos e abre sua festa, ou o formulário para criar uma, se você
          ainda não tiver.
        </p>
        <p className="muted">
          Não achou? Veja o spam. Ou{' '}
          <button className="linkish" onClick={() => setSent(false)}>
            peça outro
          </button>
          .
        </p>
      </div>
    );
  }

  return (
    <div className="page landing">
      {/* No logo here: the banner above already carries it, and twice is
          once too many. */}
      <div className="hero">
        <h1>
          Quem vem na festa?<br />
          <span className="hero-sub">Descubra sem grupo, sem planilha, sem cobrar ninguém.</span>
        </h1>
      </div>

      <div className="card lead">
        <label htmlFor="email">Seu e-mail</label>
        <input
          id="email"
          type="email"
          inputMode="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="voce@exemplo.com"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && email.includes('@')) void submit();
          }}
        />
        {error && <div className="banner error" style={{ marginTop: '0.6rem' }}>{error}</div>}
        <button
          className="primary"
          style={{ marginTop: '0.6rem' }}
          onClick={submit}
          disabled={busy || !email.includes('@')}
        >
          {busy ? 'Enviando…' : 'Começar'}
        </button>
        <p className="muted" style={{ margin: '0.6rem 0 0', fontSize: '0.85rem' }}>
          Sem senha e sem cadastro. Mandamos um link que abre sua festa.
        </p>
      </div>

      {/* Three steps because it really is three, not because three looks
          tidy. Numbering them says the order matters, and it does. */}
      <h2>Como funciona</h2>
      <ol className="steps">
        <li>
          <strong>Mande a lista da turma</strong>
          <span>
            Do jeito que a escola enviou: Excel, CSV, o que for. A gente
            entende as colunas sozinho.
          </span>
        </li>
        <li>
          <strong>Cada família ganha um link</strong>
          <span>
            Você envia pelo WhatsApp, do seu telefone, uma por uma. Sem entrar
            em grupo nenhum.
          </span>
        </li>
        <li>
          <strong>As respostas chegam prontas</strong>
          <span>
            Quem fica, quem só deixa, quantas crianças e de que idade. Dá para
            baixar a lista quando quiser.
          </span>
        </li>
      </ol>

      <h2>O que a gente não faz</h2>
      <ul className="nots">
        <li>
          <strong>Não pedimos conta nem senha.</strong> Nem de você, nem de
          quem for convidado. Um link no e-mail abre a sua festa.
        </li>
        <li>
          <strong>Não pedimos nada dos convidados.</strong> Nem e-mail, nem
          cadastro, nem aplicativo. Eles tocam no link e respondem.
        </li>
        <li>
          <strong>Apagamos tudo 2 dias depois da festa.</strong> Antes disso a
          gente te manda a lista final por e-mail, para você guardar.
        </li>
        <li>
          <strong>Não cobramos.</strong> Nem agora nem depois.
        </li>
      </ul>

      <p className="muted">Uma festa por e-mail, de cada vez.</p>
    </div>
  );
}
